export default {
  modalStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    background: '#00000094',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 100000000000,
  },
};
